// removed by extract-text-webpack-plugin
module.exports = {"base":"base___1SFW4","colorButton":"colorButton___39QTd","collapsed":"collapsed___2pslo","outline":"outline___ummr2","compact":"compact___2_Q9y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/ColorButton/index.scss
// module id = 75
// module chunks = 0